/*!
 * @monogrid/vue-boost v8.0.1 Copyright (C) MONOGRID S.R.L. - All Rights Reserved - Unauthorized copying of this file, via any medium is strictly prohibited
 */
import { useGlobalScrollLock as p } from "@monogrid/vue-boost/core";
import { unrefElement as f, useMagicKeys as m } from "@vueuse/core";
import { computed as v, watch as l, unref as d } from "vue";
import { useStackedFocusTrap as k } from "./index3.mjs";
function T(r, s, u) {
  const t = v(() => f(r)), { active: c, focusTrap: i } = k(r, { escapeDeactivates: !1, ...u }), e = p();
  let a;
  const { escape: n } = m();
  return l(n, (o) => {
    !o || !c.value || !t.value || s();
  }), l(t, (o) => {
    o ? (a = d(e), e.value = !0) : e.value = a;
  }), {
    active: c,
    focusTrap: i
  };
}
export {
  T as useModal
};
